import FormattedMessage from 'I18n/components/FormattedMessage';
import { CARD_BORDER_RADIUS, COMET, ECLIPSE } from 'developer-docs-shared-components/config/cssConstants';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection } from 'foundations-components/transitional/components/Card';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import styled from 'styled-components';
import LinkOverlay, { embeddedLinkStyles } from './LinkOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardWrapper = styled.div.withConfig({
  displayName: "WhatsNewCard__CardWrapper",
  componentId: "sc-18h6jr-0"
})(["background-color:", ";border-radius:", "px;transition:0.3s ease-in-out;&:hover{background:", ";}position:relative;"], ({
  background
}) => background, CARD_BORDER_RADIUS, ECLIPSE);
const StyledCustomLink = styled.a.withConfig({
  displayName: "WhatsNewCard__StyledCustomLink",
  componentId: "sc-18h6jr-1"
})(["color:", ";border-color:", ";", " &:hover{color:", ";border-color:", ";}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['fill-surface-default'], embeddedLinkStyles, COMET, COMET);
export const WhatsNewCard = ({
  description,
  header,
  illustration,
  link,
  background
}) => {
  const {
    isMobile
  } = useViewport() || {
    isMobile: false
  };
  return /*#__PURE__*/_jsxs(CardWrapper, {
    background: background,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      children: [!isMobile && /*#__PURE__*/_jsx(Illustration, {
        alt: illustration,
        name: illustration,
        width: 100,
        marginInlineStart: "1000"
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "start",
        children: [isMobile && /*#__PURE__*/_jsx(CardSection, {
          children: /*#__PURE__*/_jsx(Illustration, {
            paddingBlockStart: illustration === 'building' ? '400' : undefined,
            width: 80,
            height: 95,
            name: illustration,
            alt: illustration
          })
        }), /*#__PURE__*/_jsx(CardSection, {
          paddingBlockEnd: "600",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h3",
            color: "text-primary-on-fill-default",
            children: header
          })
        }), /*#__PURE__*/_jsx(CardSection, {
          paddingBlockEnd: "700",
          children: /*#__PURE__*/_jsx(Text, {
            color: "text-primary-on-fill-default",
            typography: "body-200",
            children: description
          })
        }), /*#__PURE__*/_jsx(CardSection, {
          children: /*#__PURE__*/_jsx(StyledCustomLink, {
            href: link,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.mainLandingPage.whatsNew.buttonText"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(LinkOverlay, {
      to: link
    })]
  });
};